
// libs:
import Vue from 'vue'
import VueRouter from 'vue-router'

export const navList = [
  {
    title: '微信社群'
    ,icon: 'home'
  }
  ,{
    title: '关注我们'
    ,icon: 'location_on'
  }
  ,{
    title: '加入我们'
    ,icon: 'groups'
  }
  ,{
    title: '商务合作'
    ,icon: 'favorite'
  }
]

// data: router
const router = (()=> {
  Vue.use(VueRouter)
  return new VueRouter({
    mode: 'history'
    ,routes: []
  })
})()

export default router
